import { state } from './models';
import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';

export const productMasterModule = {
  state,
  getters,
  actions,
  mutations,
};
